export const QUERY_KEYS = { GET_CUSTOM_FIELDS: 'GET_CUSTOM_FIELDS' };
export const CUSTOM_FIELDS_AUTOMATIONS_PREFIX = 'cf_';
export const CUSTOM_FIELDS_TRIGGER_SUFFIX = 'is updated';
export const CUSTOM_FIELDS_AUTOMATIONS_REGEX = new RegExp(`${CUSTOM_FIELDS_AUTOMATIONS_PREFIX}`);
export const CUSTOM_FIELDS_TYPES = {
    DROPDOWN: 'DROPDOWN',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    TEXT: 'TEXT',
};
export const CUSTOM_FIELD_ACTION_TYPE = 'custom-field';
export const CUSTOM_FIELD_CONDITION_TYPE = 'custom-field';
export const GAINSIGHT_EVENTS = {
    CF_TRIGGER: 'TriggerCF_viaAutomation',
    CF_CONDITION: 'ConditionCF_viaAutomation',
    CF_ACTION: 'ActionCF_viaAutomation',
    CF_SCHEDULE_AUTOMATIONS: 'ScheduledAutomation_created',
    CF_IMMEDIATE_AUTOMATIONS: 'ImmediateAutomation_created',
    CF_CREATED_CLICKED: 'DateTypeCF_CreateNowClicked'
};
export const TEXT_FIELD_CHARACTER_LIMIT = 5000;
export const NUMBER_FIELD_CHARACTER_LIMIT = 10;
export const CF_DATE_FROMAT = 'YYYY-MM-DD HH:mm:ss';
export const OPTIONS_REQUIRED_EXTRA_PAYLOAD = ['after', 'before', 'within'];
export const CF_GROUP = "custom-field-group"
export const CF_DIVIDER_TEXT = "CUSTOM FIELDS"
export const CF_ACTION_DROPDOWN_DIVIDER_ELEMENT = {
    label: CF_DIVIDER_TEXT,
    isDivider: true,
    // tried max-content didn't work
    wordWidth: "105px"
}